var CurrentUser = require("lib/account/CurrentUser");

const COMPONENTS_TO_TAG = ["NewEssayPage"]

var LuckyOrangeClient = {
	forced: false,
	userTagged: false,
	lo_id: 149493,
	init: function() {
		if ( $wr.isProduction()) {
			// window.__lo_log_console = true;
			// window.__lo_site_id = this.lo_id;

			var wa = document.createElement('script');
			wa.type = 'text/javascript';
			wa.async = true;
			wa.src = 'https://tools.luckyorange.com/core/lo.js?site-id=29d2c8b1';
			var s = document.getElementsByTagName('script')[0];
			s.parentNode.insertBefore(wa, s);
		}
	},

	tagUser: function() {
		var user = CurrentUser.get();
		if (!user) {
			window._loq.push(["tag", "signedOut"]); // PRODUCT
			return;
		}
		window._loq = window._loq || []; // ensure queue available
  		window._loq.push(["tag", "user_id:" + user.id]); // USER ID
  		window._loq.push(["tag", user.account.product]); // PRODUCT
  		var role = user.role;
  		window._loq.push(["tag", role]); // ROLE

  		
  		if ( role == "studentRole") {
  			if ( user.primary_student_list ) {
  				window._loq.push(["tag", "primary_student_list_id:" + user.primary_student_list.id]); // PRODUCT
  			}
  			if ( user.pending_onboarding ) {
				window._loq.push(["tag", "studentOnboarding"]);
			}
  		} else {
  			if ( user.pending_onboarding ) {
				window._loq.push(["tag", "adminOnboarding"]);
			}
			// CHECK FOR PEDING CHECKLIST
			if (this.isOnboardingComplete(user)) {
				window._loq.push(["tag", "onboardingChecklistComplete"]);
			} else {
				window._loq.push(["tag", "onboardingChecklistPending"]);
			}
  		}
  		if ( user.school ) {
			window._loq.push(["tag", "school_canonical_id:" + user.school.canonical_id]); // PRODUCT
		}
  		if ( user.grade_level ) {
  			window._loq.push(["tag", "grade_level:" + user.grade_level]);
  		}
  		if ( user.last_active == null ) {
  			window._loq.push(["tag", "first_session"]);
  		}
  		if ( $wr.isProduction() ) {
  			window._loq.push(["tag", "production"]);
  		} else {
  			window._loq.push(["tag", "development"]);
  		}

  		this.userTagged = true

	},
	tagSplitTest: function() {
		if (typeof Mycroft != "undefined") {
			_.each(Mycroft.splitTests, (test) => {
				window._loq.push(["tag", test.full_variation]);
			})
		}
	},
	getAdoptionFunnel: function(user) {
		var created_at = new Date(user.created_at)
		var now = new Date()
		const diffTime = Math.abs(created_at.getTime() - now.getTime());
		const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
		if (diffDays < 1) {
			window._loq.push(["tag", "first_day"]);
		} else if (diffDays < 8) {
			window._loq.push(["tag", "first_week"]);
		} else if (diffDays < 15) {
			window._loq.push(["tag", "second_week"]);
		} else if (diffDays < 32) {
			window._loq.push(["tag", "first_month"]);
		} else if (diffDays < 62) {
			window._loq.push(["tag", "second_month"]);
		} else {
			window._loq.push(["tag", "three_months_plus"]);
		}
	},
	isOnboardingComplete: function(user) {
		if (user && user.prefs && user.prefs.onboarding) {
			var values = _.values(user.prefs.onboarding)
			return values.filter(function(item){return !item}).length == 0
		}
		return true
	},
	shouldRecord(reactComponent) {
		if (!$wr.isProduction()) return false
		
		var user = CurrentUser.get();
		var shouldRecord = false;
		if (!user) { // So we record signed out people on class page
			// shouldRecord = true
		} else if (user.role == "teacherRole" || user.role == "adminRole") {
			// if (user.pending_onboarding || !this.isOnboardingComplete(user) || user.product == "wrSilver" || user.product == "wrGold") {
				shouldRecord = true
			// }
		} else if (user.role == "studentRole" && user.product == "wrGold" && COMPONENTS_TO_TAG.includes(reactComponent)){
			shouldRecord = true
		}
		else {
			if (user && user.demo_for_teacher) {
				shouldRecord = true
			}
		}
		if (shouldRecord && !window.__lo_site_id) {
			this.init();
		}
		return shouldRecord
	},
	forceRecording() {
		// return false;
		// this.forced = true;
		// if (!window.__lo_site_id) {
		// 	this.init();
		// 	this.tagUser()
		// }
	},
	reset() {
		this.forced = false;
	},
	tagComponent: function(reactComponent) {
		// if they are already tagged, allow to pass whatever element.
		if (this.shouldRecord(reactComponent) || this.userTagged) {
			try {
				if (!this.userTagged) {
					this.tagUser()
				}
				window._loq = window._loq || [];
				if (typeof reactComponent == "string") {
					var name = reactComponent
				} else {
					var name = reactComponent.constructor.name.replace("bound ","")
				}
				window._loq.push(["tag", name]);
			} 
			catch(err) {
				console.log("LO issue");
			}
		}
	}
}

module.exports = LuckyOrangeClient;



// WEBPACK FOOTER //
// ./modules/lib/integrations/LuckyOrangeClient.js